// extracted by mini-css-extract-plugin
export default {"body-summary":"style_body-summary__XqbpV","summary-item":"style_summary-item__kC6uY","item-count":"style_item-count__CYKQM","item-count-row":"style_item-count-row__SYOPU"};